import { API_URL } from "../config";
import { setLoading } from "../store/slices/articleDetail-slice";
import {
  setConfigParams,
  setCountry,
  setParamsWeb,
} from "../store/slices/paramsWeb-slice";
import { adapterMessage } from "../adapters/message";
import { showToast } from "../toast/toastManager";

export const fetchParamsWeb = () => async (dispatch) => {
  const url = `${API_URL}/api/v1/Parametros`;

  try {
    dispatch(setLoading(true));

    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    const { data, message } = await response.json();
    const { message: mensaje } = adapterMessage(message);

    if (response.status === 404) {
      dispatch(setParamsWeb([]));
      dispatch(setConfigParams({}));
      return;
    }

    if (!response.ok) {
      throw new Error(mensaje || `HTTP error! Status: ${response.status}`);
    }

    const parametros = data?.parametros || [];
    dispatch(setParamsWeb(parametros));

    const configParams = parametros.reduce((acc, curr) => {
      acc[curr.Nombre] = curr.Valor;
      return acc;
    }, {});

    dispatch(setConfigParams(configParams));
  } catch (error) {
    showToast(`${error.message}`, "error", "bottom-left");
  } finally {
    dispatch(setLoading(false));
  }
};

export const fetchCountry = () => async (dispatch) => {
  const url = `${API_URL}/api/v1/Paises`;

  try {
    dispatch(setLoading(true));

    const response = await fetch(url, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });

    const { data, message } = await response.json();
    const { message: mensaje } = adapterMessage(message);

    if (response.status === 404) {
      dispatch(setCountry({ paises: [], departamentos: [], municipios: [] }));
      return;
    }

    if (!response.ok) {
      throw new Error(mensaje || `HTTP error! Status: ${response.status}`);
    }

    dispatch(setCountry(data));
  } catch (error) {
    showToast(`${error.message}`, "error", "bottom-left");
  } finally {
    dispatch(setLoading(false));
  }
};
